import { OnInit } from '@angular/core';
var AboutComponent = /** @class */ (function () {
    function AboutComponent() {
    }
    AboutComponent.prototype.ngOnInit = function () { };
    return AboutComponent;
}());
export { AboutComponent };
